/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Access_Specific_DescInputs */



/**
* | output |
* | --- |
* | "Only the event groups you choose." |
*
* @param {Team_Share_Access_Specific_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_access_specific_desc = /** @type {((inputs?: Team_Share_Access_Specific_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Access_Specific_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Only the event groups you choose.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Only the event groups you choose.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Only the event groups you choose.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Only the event groups you choose.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Only the event groups you choose.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Only the event groups you choose.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Only the event groups you choose.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Only the event groups you choose.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Only the event groups you choose.")
	return /** @type {LocalizedString} */ ("Only the event groups you choose.")
});